/**
 * @generated SignedSource<<e415929685768d8d61cefbc5e2faec3d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RetellingStatus = "FAILED" | "PENDING" | "READY" | "%future added value";
export type RetellingFeedbackRetryMutation$variables = {
  id: string;
};
export type RetellingFeedbackRetryMutation$data = {
  readonly retryRetelling: {
    readonly retelling: {
      readonly id: string;
      readonly status: RetellingStatus;
    };
  };
};
export type RetellingFeedbackRetryMutation = {
  response: RetellingFeedbackRetryMutation$data;
  variables: RetellingFeedbackRetryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RetryRetellingPayload",
    "kind": "LinkedField",
    "name": "retryRetelling",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Retelling",
        "kind": "LinkedField",
        "name": "retelling",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RetellingFeedbackRetryMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RetellingFeedbackRetryMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "6773e91e081e7d469f23a81f8f576f67",
    "id": null,
    "metadata": {},
    "name": "RetellingFeedbackRetryMutation",
    "operationKind": "mutation",
    "text": "mutation RetellingFeedbackRetryMutation(\n  $id: ID!\n) {\n  retryRetelling(id: $id) {\n    retelling {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "307f51b712e60fa1d6f4d8ea500e1b4c";

export default node;
